import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useEffect, useState, useRef } from 'react';
import UserGoBack from "../../user/UserGoBack";
import TagsAnchorContainer from "../TagsAnchorContainer";
import ArticleUtile from "../ArticleUtile";
import RightPartContent from "../RightPartContent";
import { useNavigate } from "react-router-dom";
import { useSectionRefs } from "../../../hooks/useSectionRefs";

const HelpTopicNotification = () => {
  const { auth, setOngletPaiementActif, windowWidth } = useContext(dataApplicationsContext);
  const { anchorsParts, topic, isLoading, LoadingComponent } = useSectionRefs();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Votre compte', link: '/topics/compte'},
    { label: 'Gérer votre compte', link: '/topics/compte/gestion-compte'},
    { label: topic.title, link: topic.link},
  ]


  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Vous pouvez choisir le type de notifications que vous recevez et la façon dont vous les recevez en vous rendant 
              dans la section<a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/compte/notifications`}>Notifications.</a> Vous avez le choix parmi les options suivantes : SMS ou e-mails.
            </p>
            <button className="contact-btn" onClick={() => window.open(`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/compte/notifications`, '_blank')}>Accéder aux paramètres de notification</button>
            <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/>
            <div className="article-container mt-40" ref={anchorsParts[0].ref}>
              <p className="help-title-part">{anchorsParts[0].content}</p>
              <ul>
                <li className="help-text pl-8 mb-16"><strong>Rappels et suggestions</strong> : rappels de inscriptions, conseils utiles pour améliorer votre compétition et autres messages liés à vos activités sur Wodzone.</li>
                <li className="help-text pl-8 mb-16"><strong>Promotions et astuces</strong> : coupons, promotions, enquêtes, mises à jour de produits, et idées de Wodzone.</li>
                <li className="help-text pl-8 mb-16"><strong>Assistance relative au compte</strong> : informations sur votre compte, aux compétitions, aux mises à jour juridiques, à la sécurité et la confidentialité du compte, et demandes envoyées à l'assistance utilisateurs.</li>
              </ul>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[1].ref}>
              <p className="help-title-part mb-8">{anchorsParts[1].content}</p>
              <p className="help-text">
                Vous pouvez désactiver la plupart des alertes en vous rendant dans la section 
                <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/compte/notifications`}>Notifications.</a>
                Vous pouvez également procéder comme suit :
              </p>
              <ul>
                <li className="help-text pl-8 mb-16"><strong>SMS</strong> : répondez STOP. Pour les recevoir à nouveau, répondez START.</li>
                <li className="help-text pl-8 mb-16"><strong>E-mails</strong> : cliquez sur <strong>se désabonner</strong> dans le corps de l'e-mail.</li>
              </ul>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[2].ref}>
              <p className="help-title-part mb-8">{anchorsParts[2].content}</p>
              <p className="help-text">Il est important de ne pas passer à côté des notifications concernant :</p>
              <ul>
                <li className="help-text pl-8 mb-16">Les réservations</li>
                <li className="help-text pl-8 mb-16">L'activité du compte</li>
                <li className="help-text pl-8 mb-16">Les mises à jour légales</li>
                <li className="help-text pl-8 mb-16">Les avis de sécurité et de confidentialité</li>
                <li className="help-text pl-8 mb-16">Les demandes envoyées à l'équipe d'assistance</li>
              </ul>
              <p className="help-text">
                Dans certains cas, notamment lorsque nous ne pouvons pas vous joindre par e-mail, 
                nous serons peut-être amenés à vous contacter par téléphone ou par d'autres moyens.
              </p>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicNotification